import { Chakra } from "@airhelp/react-ui-components";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import type { ComparisonCardProps } from "./ComparisonCard.d";

const { Divider, VStack, ListItem, Heading, Tag, Box } = Chakra;

const setHighlightStyles = (isHighlighted) =>
  isHighlighted
    ? { outline: "4px solid", outlineColor: "primary.500", order: { base: 0, lg: 1 } }
    : { outline: "1px solid ", outlineColor: "greyscale.400", order: 1 };

const ComparisonCard = ({ tagText, heading, highlighted, content = [], bgColor }: ComparisonCardProps) => (
  <ListItem
    d="flex"
    flexDir="column"
    p={8}
    px={{ base: 4, lg: 8 }}
    bg={bgColor}
    borderRadius="lg"
    flex="1"
    h={{ base: "100%", lg: "unset" }}
    {...setHighlightStyles(highlighted)}
  >
    <Box minH={{ lg: 6 }} mb={{ lg: 3 }} mx="auto">
      {tagText && (
        <Tag size="xs" colorScheme="success" variant="primary" mb={{ base: 3, lg: 0 }}>
          {tagText}
        </Tag>
      )}
    </Box>
    <Heading textAlign="center" variant="h4" as="h4">
      {heading}
    </Heading>
    <Divider my={5} borderColor="greyscale.400" />
    <VStack spacing={8} alignItems="stretch">
      {content.map((item) => (
        <DynamicComponent key={item._uid} blok={item} />
      ))}
    </VStack>
  </ListItem>
);

export default ComparisonCard;
